// src/components/common/index.js
import React from 'react';
import PropTypes from 'prop-types';

export const Loader = ({ message }) => (
  <div className='p-4 text-center text-sm text-gray-500 animate-pulse'>
    {message || 'Loading…'}
  </div>
);
Loader.propTypes = { message: PropTypes.string };

export const ErrorBanner = ({ message }) => (
  <div className='p-4 text-red-600 bg-red-50 border border-red-200 rounded-md'>
    {message}
  </div>
);
ErrorBanner.propTypes = { message: PropTypes.string.isRequired };
